export default "__VITE_ASSET__dZcKQGKd__"